"use strict";

(function (global) {
  /**
  * Функции отвечающие за работу с реквизитами.
  * @namespace Core.requisites
  * @since 5.5.0.1000
  */
  global.requisites = {};
})(window.Core);
